export function generateDots(counts) {
    return Array.from(Array(counts).keys());
}
